import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dd-qrcode-container" }
const _hoisted_2 = { class: "qrcode-box" }
const _hoisted_3 = { class: "qrcode-desc" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")
  const _directive_touch = _resolveDirective("touch")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode(_component_qrcode_vue, {
        size: 95,
        value: _ctx.qrcodeInfo.url
      }, null, 8, ["value"]), [
        [_directive_touch, _ctx.longtapHandler, "longtap"]
      ])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("span", null, _toDisplayString(_ctx.qrcodeInfo.desc), 1)
    ])
  ]))
}